module.exports = __webpack_public_path__ + "static/media/nittigrotesk-regular.4cfaf3a8.otf";